import { useDispatch, useSelector } from "react-redux";
import VendordataNonEditablePart from "./VendordataNonEditablePart";
import { vendordataSelector } from "reducers/vendordata/vendordata";
import {
  appdataSelector,
  appdata_getRegionsForCountry
} from "reducers/appdata/appdata";
import { useEffect } from "react";
import { formatData } from "./VendordataHelper";

function VendordataNonEditable() {
  const vendordata = useSelector(vendordataSelector);
  const appdata = useSelector(appdataSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(
      "VendordataNonEditable",
      vendordata.activeVendor,
      appdata.listvalues
    );
    if (
      !appdata.listvalues.regionsForCountry &&
      vendordata.activeVendor.COMPANY &&
      vendordata.activeVendor.COMPANY.COMP_COUNTRY
    ) {
      dispatch(
        appdata_getRegionsForCountry(
          vendordata.activeVendor.COMPANY.COMP_COUNTRY
        )
      );
    }
  }, [vendordata.activeVendor]);


  let part = vendordata.vendorParts.COMPANY;
  let generalData = vendordata.activeVendor.COMPANY ? formatData("COMPANY", part, appdata, vendordata) : {};

  // check company for multi language data
  let extraCompanyData = [];
  if (vendordata.activeVendor.COMPANY) {
    let suffixes = [];
    appdata.listvalues.languagesForGeneralData.map((value) => {
      let suffix = "_" + value.NATION;

      // look for valid data that ends with a language on the vendor company
      Object.keys(vendordata.activeVendor.COMPANY).map(key => {
        if (key.substring(key.length - 2) == suffix) {
          // part is for language suffix
          if (vendordata.activeVendor.COMPANY[key] != null) {
            // language part has value, add the suffix to the list 
            if (!suffixes.includes(value.NATION)) suffixes.push(value.NATION)
          }
        }
      })
    });

    
    if (suffixes.length > 0) {

      let part = { ...vendordata.vendorParts.COMPANY };

      delete part["COMP_PROF"];
      delete part["COMP_PTERMS"];
      delete part["COMP_MEMO"];
      delete part["COMP_PMETHOD"];
      delete part["COMP_TYPE"];
      delete part["COMP_REG_NO"];
      delete part["COMP_VAT_REG"];
      delete part["COMP_RECON_ACCT"];

      suffixes.map(suffix => {
        extraCompanyData.push(formatData("COMPANY", part, appdata, vendordata, suffix))
      })
    }
  }

  let partContact = vendordata.vendorParts.CONTACT;
  let contactData = vendordata.activeVendor.CONTACT ? formatData("CONTACT", partContact, appdata, vendordata) : {};

  let partBank = vendordata.vendorParts.BANK;
  let bankData = vendordata.activeVendor.BANK ? formatData("BANK", partBank, appdata, vendordata) : {};


  let partPurchasing = vendordata.vendorParts.PURCHASING;
  let purchasingData = vendordata.activeVendor.PURCHASING ? formatData("PURCHASING", partPurchasing, appdata, vendordata) : {};

  return (
    <div className="mt-4">
      <hr></hr>

      <h2 className="article-title mb-2">General Data</h2>
      <VendordataNonEditablePart data={generalData}></VendordataNonEditablePart>

      {/* general data in other languages */}
      {/* general data in other languages */}
      {/* general data in other languages */}
      {/* general data in other languages */}
      {extraCompanyData.length > 0 && (
        extraCompanyData.map(data => {
          return (
            <VendordataNonEditablePart data={data}></VendordataNonEditablePart>
          )
        })
      )}
      <hr></hr>

      <h2 className="article-title mb-2 mt-4">Contacts</h2>
      <VendordataNonEditablePart data={contactData} multi={true}></VendordataNonEditablePart>
      <hr></hr>

      <h2 className="article-title mb-2 mt-4">Bank</h2>
      <VendordataNonEditablePart data={bankData} multi={true}></VendordataNonEditablePart>
      <hr></hr>

      <h2 className="article-title mb-2 mt-4">Purchasing Organisation</h2>
      <VendordataNonEditablePart data={purchasingData}></VendordataNonEditablePart>
    </div>
  );
}

export default VendordataNonEditable;
